import Findable from '../mixins/Findable.js';
class ShareClient {
    static service = 'file-system.share';
    apiClient;
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    share(params) {
        const endpoint = this.makeEndpoint('share');
        return this.apiClient.exec(endpoint, params);
    }
    create(params) {
        const endpoint = this.makeEndpoint('create');
        return this.apiClient.exec(endpoint, params);
    }
    exists(params) {
        const endpoint = this.makeEndpoint('exists');
        return this.apiClient.exec(endpoint, params);
    }
    findByLink({ link, specs, }) {
        const endpoint = this.makeEndpoint('find-by-link');
        return this.apiClient.exec(endpoint, {
            link,
            specs,
        });
    }
    update(params) {
        const endpoint = this.makeEndpoint('update');
        return this.apiClient.exec(endpoint, params);
    }
    remove(params) {
        const endpoint = this.makeEndpoint('remove');
        return this.apiClient.exec(endpoint, params);
    }
    makeEndpoint(operation) {
        return `${ShareClient.service}/${operation}`;
    }
}
// Decorate service with mixins
const DecoratedClient = Findable(ShareClient);
export default DecoratedClient;
